module.exports = __webpack_public_path__ + "img/lock-bg.562b49ed.png";